import uiConfig from 'src/lib/ui/config';
import { ImageCoverView } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import { EditorScreen } from '../minigame/match2-timestep/editor/EditorScreen';
import {
  getPuzzleMap,
  setEditorOverride,
} from '../minigame/match2-timestep/match2.assets';
import Observer from '../minigame/match2-timestep/lib/pattern/Observer';
import { editorGetInitialLevel } from '../minigame/match2-timestep/editor/editor.utils';
import { loadMatch2LevelAssets } from 'src/loadMatch2LevelAssets';
import { installMatch2EditorAutomation } from '../minigame/match2-timestep/editor/editor.automation';

export default class Match2EditorScene extends ResponsiveScene {
  public level = 0;
  public onLevelChange = new Observer<number>();

  public editor!: EditorScreen;

  private copyListener?: () => void;
  private pasteListener?: (event: ClipboardEvent) => void;

  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        backgroundColor: '#222222',
      }),
    );
  }

  public async setLevel(level: number) {
    try {
      const mapDef = await getPuzzleMap(level);
      this.editor!.setMapDef(mapDef);
    } catch (e) {
      window.alert(`BROKEN LEVEL: ${level}`);
      console.error(e);
      this.editor!.grid.clear();
    }
    this.level = level;
    this.onLevelChange.publish(this.level);
  }

  public override async showScene() {
    // Preload map and level assets
    await loadMatch2LevelAssets();

    this.editor = new EditorScreen(this);

    this.copyListener = () => {
      console.log('Exporting map to clipboard');
      this.editor.copy();
    };

    this.pasteListener = (event) => {
      console.log('Importing map from clipboard');
      event.preventDefault();
      // Files detected
      if (event.clipboardData?.files.length) {
        // For each file override the level
        for (let i = 0; i < event.clipboardData.files.length; i++) {
          const file = event.clipboardData.files[i];
          const reader = new FileReader();
          reader.onload = (e) => {
            const text = e.target?.result;
            if (typeof text !== 'string') return;
            try {
              console.log('Importing file', file.name);
              const level = parseInt(file.name.replace(/\D/g, ''));
              setEditorOverride(level, JSON.parse(text));
            } catch (e) {
              console.error('Could load file' + file.name, e);
            }
          };
          reader.readAsText(file);
        }

        return;
      }

      const text = event.clipboardData?.getData('text');
      if (text) {
        this.editor!.paste(text);
      } else {
        console.error('No text in clipboard!');
      }
    };

    window.addEventListener('copy', this.copyListener);
    window.addEventListener('paste', this.pasteListener);

    const { width, height } = this.getView().style;
    this.editor.resize(width, height);

    this.editor.init();

    await this.setLevel(editorGetInitialLevel());

    installMatch2EditorAutomation(this);
  }

  public override hideScene() {
    window.removeEventListener('copy', this.copyListener!);
    window.removeEventListener('paste', this.pasteListener!);
  }
}
